<div mat-dialog-title>
  <span>{{ 'AI_CHAT.ASK_ASSISTANT' | translate }}</span>

  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<div class="q9-modal-error" *ngIf="apiError() as error">
  <div class="text">{{ error }}</div>
</div>

<mat-dialog-content class="ai-chat-dialog-content">
  <mat-drawer-container [hasBackdrop]="false">
    <mat-drawer mode="side" opened="true" class="history-container">
      <div>
        <q9-primary-button
          class="new-chat-btn"
          (click)="resetChat()"
          q9Track="AI_CHAT.NEW_CHAT"
          [disabled]="!isAssistantEnabled()">
          {{ 'AI_CHAT.NEW_CHAT' | translate }}
        </q9-primary-button>
      </div>

      <ai-chat-history></ai-chat-history>
    </mat-drawer>

    <mat-drawer-content>
      <nav mat-tab-nav-bar mat-stretch-tabs="false" [tabPanel]="tabPanel">
        <a
          mat-tab-link
          [q9Track]="['AI_CHAT', assistant.label]"
          *ngFor="let assistant of assistants()"
          (click)="resetChat(assistant.type)"
          [active]="selectedAssistant() === assistant.type">
          {{ assistant.label | translate }}
        </a>

        <q9-icon-button
          icon="question"
          class="support-link"
          [disabled]="!isAssistantEnabled()"
          (click)="openSupportPage()"
          [tooltip]="'CORE.TOOLBAR.HELP_ME' | translate"></q9-icon-button>
      </nav>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

      <div class="messages" #messageList>
        <div class="chat-date">{{ chatDate() }}</div>

        <ng-container *ngIf="isAssistantEnabled(); else assistantNotEnabled">
          <ai-chat-message
            [message]="message"
            *ngFor="let message of messages$ | async"></ai-chat-message>

          <ai-chat-error></ai-chat-error>
        </ng-container>
        <ng-template #assistantNotEnabled>
          <div class="assistant-warning">{{ 'AI_CHAT.ASSISTANT_NOT_ENABLED' | translate }}</div>
        </ng-template>
      </div>

      <ai-chat-input [triggerResetInput]="triggerResetInput()"></ai-chat-input>

      <span
        class="hallucinations-warning"
        [innerHTML]="'AI_CHAT.HALLUCINATIONS_WARNING' | translate | decodeHtml"></span>
    </mat-drawer-content>
  </mat-drawer-container>
</mat-dialog-content>
